module.exports = __webpack_public_path__ + "check-tenant@3x.340f19099fda88e8990564faebe50fe1.png";